module.exports = __webpack_public_path__ + "static/media/gain_smarts.15bf720d.png";